<template>
	<el-form ref="form" :model="form" label-width="80px" style="margin:20px;width:60%;min-width:600px;">
		<el-form-item label="旧密码">
			<el-input type="password" v-model="form.oldPass"></el-input>
		</el-form-item>
		<el-form-item label="新密码">
			<el-input type="password" v-model="form.newPass"></el-input>
		</el-form-item>
		<el-form-item label="确认密码">
			<el-input type="password" v-model="form.confirmPass"></el-input>
		</el-form-item>
		<el-form-item>
			<el-button type="primary" :loading="loading" @click.native.prevent="onSubmit">更新</el-button>
			<el-button @click.native.prevent="cancel">取消</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
	import { changePw } from '../api/api';
	export default {
		data() {
			return {
				form: {
					oldPass: '',
					newPass: '',
					confirmPass: '',
				},
				loading: false,
			}
		},
		methods: {
			async onSubmit() {
				if (!this.form.oldPass || this.form.oldPass.trim().length < 6) {
					this.$message({
						message: '旧密码必须至少6位',
						type: 'warning'
					});
					return 
				}
				if (!this.form.newPass || this.form.newPass.trim().length < 6) {
					this.$message({
						message: '新密码必须至少6位',
						type: 'warning'
					});
					return
				}
				if (this.form.newPass !== this.form.confirmPass) {
					this.$message({
						message: '两次密码必须相等',
						type: 'warning'
					});
					return
				}
				this.loading = true;
				const res = await changePw(this.form);
				this.loading = false;
				if (res.data.status !== 200) {
					this.$message({
					message: res.data.message,
					type: 'success'
					});
					return
				}
				this.$message({
					message: '更新成功',
					type: 'success'
				});
				this.$router.replace('/login')
			},
			cancel() {
				this.$router.back()
			}
		}
	}

</script>


// WEBPACK FOOTER //
// Password.vue?0cb7b816